export interface IParametrosUsuario {
   numParametro: number;
   parametro: string;
   valor: string;
   tipo: string;
   codCpf: string;
   codTipoEscaninho: number;
}

export interface IValidacaoParametroUsuario {
   nome: string;
   valor: string;
}

export const parametroDefault = {
   numParametro: null,
   parametro: '',
   valor: 'true',
   tipo: '',
   codCpf: '',
   codTipoEscaninho: 0,
} as IParametrosUsuario;

export const textosParametrosUsuarioColunas = {
   OJC: 'Coluna de informações sobre o OJC',
   RESPONSAVEL: 'Coluna de informações sobre o responsável da minuta',
   MOVIMENTACAO: 'Coluna de informações sobre movimentações internas do processo',
   MINUTAS: 'Coluna de informações sobre a(s) minuta(s) criada(s) para o processo'
}

export const textosParametrosUsuarioFiltros = {
   FORA_DO_FLUXO: 'Filtro de processos fora do fluxo',
   ASSINATURA: 'Filtros de processos por tipo e situação da assinatura',
   ORIGEM: 'Filtro de processos por Origem (PJe ou legado)',
   NUMERO_PROCESSO: 'Filtro de processos por número completo',
   LISTA_PROCESSO: 'Filtro de lista de processos',
   OJC_FILTRO: 'Filtro por OJC dos processos',
   ANDAMENTO: 'Filtro por andamento dos processos',
   MOVIMENTACAO: 'Filtro por movimentações dos processos',
   ANO_AUTUACAO: 'Filtro por ano de autuação dos processos',
   ETIQUETA: 'Filtro por etiquetas dos processos',
   RESPONSAVEL: 'Filtro por responsável pelos processos',
   RELATOR: 'Filtro por relator dos processos',
   POSSUI_RESPONSAVEL: 'Filtro indicando se os processos possuem algum responsável',
   INDICADOR: 'Filtro por indicadores dos processos',
   CLASSE: 'Filtro por classe dos processos',
   ASSUNTO: 'Filtro por assunto dos processos',
   CATEGORIA: 'Filtro por categoria dos processos',
   INCLUSAO_PAUTA: 'Filtro indicando se o processo foi incluído em pauta',
   MOVIMENTO: 'Filtro por movimentos dos processos',
   PARTES: 'Filtro por partes dos processos',
   RESULTADO_JULGAMENTO: 'Filtro por resultado de julgamento dos processos',
   SITUACAO_MINUTA: 'Filtro por situação da(s) minuta(s) dos processos',
   PETICAO: 'Filtros de processos com ou sem petição pendente',
   IMPEDIMENTO: 'Filtro por impedimentos dos processos',
   TIPO_JULGAMENTO: 'Filtro por tipo de julgamento dos processos',
   POSSUI_MINUTA: 'Filtro indicando se existe(m) minuta(s) e seu(s) tipo(s) nos processos',
   UNIDADE_PUBLICADORA: 'Filtro por unidade publicadora dos processos',
   PUBLICAVEL: 'Filtro indicando se o processo foi marcado como publicável ou não',
   CORRE_JUNTO_ASSOCIADO: 'Filtro de processos associados ou que correm junto',
   FAVORITO: 'Filtro dos processos favoritos (estrela)',
   REDATOR: 'Filtro por redator dos processos',
   RETORNO_GABINETE: 'Filtro por indicação de retorno ao gabinete dos processos',
   TRIAGEM_LIVRE: 'Filtro por triagem livre dos processos',
   TIPOS_PETICOES_PENDENTES: 'Filtro por tipos de petições pendentes dos processos',
   VOTO_LIBERADO: 'Filtro por situação de liberação do voto'
}

export const textosParametrosUsuarioIcones = {
   ICONE_ORIGEM: 'Ícone que indica origem dos processos (PJe ou Legado)',
   ICONE_GE: 'Ícone que indica se o processo já se encontra importado para o GE',
   ESPELHO: 'Ícone para abrir o espelho dos processos',
   BEM_TE_VI: 'Ícone para abrir o sistema Bem-te-vi',
   ADICIONAR_TRIAGEM: 'Ícone para adicionar triagem livre aos processos',
   ADICIONAR_ETIQUETA: 'Ícone para adicionar etiquetas aos processos',
   ADICIONAR_MOVIMENTACAO: 'Ícone para adicionar movimentações aos processos',
   ATUALIZAR_DADOS: 'Ícone para atualizar os dados dos processos',
   COPIAR_NUMERO: 'Ícone para copiar o número dos processos',
   RESUMO_AGUIA: 'Ícone para abrir o resumo de documentos do ÁguIA',
   INTEIRO_TEOR: 'Ícone para abrir o inteiro teor dos processos',
   PETICOES_PENDENTES: 'Ícone que indica petições pendentes nos processos',
   RETORNO_GABINETE: 'Ícone que indica retorno dos processos ao gabinete',
   IMPEDIMENTO: 'Ícone que indica impedimentos nos processos',
   RELATOR_ORIGINAL: 'Ícone que indica o relator original dos processos',
   ASSOCIADO: 'Ícone que indica processos associados',
   CORRE_JUNTO: 'Ícone que indica processos que correm junto'
}

export const validacaoDefault = {} as IValidacaoParametroUsuario;
